"use client";

import React from "react";
import { Shield, Target, Users, Zap, Heart, Globe } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const valuesData = [{
  icon: Shield,
  title: "Trygg Transformation",
  description: "Vi bygger förtroende genom transparens och säkerhet. Varje AI-lösning vi implementerar vilar på en stabil grund av etisk integritet."
}, {
  icon: Target,
  title: "Målfokuserad Logik",
  description: "Vi levererar mätbara resultat genom strategisk precision. Vår teknik är utformad för att lösa verkliga affärsutmaningar effektivt."
}, {
  icon: Users,
  title: "Mänsklig AI",
  description: "Tekniken är till för människan, inte tvärtom. Vi skapar tillgängliga lösningar som främjar samarbete och användarvänlighet."
}, {
  icon: Zap,
  title: "Logistik & säkerhet",
  description: "AI-drivna lösningar för att upptäcka risker, förebygga bedrägerier och optimera logistikflöden i realtid."
}, {
  icon: Heart,
  title: "Empatisk Design",
  description: "Vi lyssnar på era behov för att förstå de unika utmaningar ni möter. Våra lösningar är skapade med omsorg för slutanvändaren."
}, {
  icon: Globe,
  title: "Skalbar Framtid",
  description: "Våra SaaS-plattformar är byggda för att växa med er. Vi kombinerar lokal expertis med ett globalt perspektiv på innovation."
}];
export default function ValuesMission() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="233765" id="intelligent-innovation" className="bg-background text-foreground py-20 md:py-24 overflow-hidden">
      <div ref={ref} className={`max-w-7xl mx-auto px-6 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center max-w-3xl mx-auto mb-20">
          <h2 className="font-default text-5xl md:text-6xl font-bold text-primary mb-6 tracking-tight">
            Vår Värdegrund & Vision
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl font-default">
            IFA AI TECH LOGIC AB drivs av principer som förenar avancerad logik med mänsklig insikt. 
            Vi möjliggör digital transformation genom innovativa och trygga lösningar.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {valuesData.map((item, i) => {
          const Icon = item.icon;
          return <Card key={i} data-index={i} className="border border-border border-t-2 border-t-ring/30 rounded-xl shadow-sm hover:shadow-md hover:-translate-y-1.5 hover:border-b-2 hover:border-b-ring transition-all duration-300 bg-gradient-to-br from-accent via-background to-background h-full overflow-hidden">
                <CardHeader className="pb-4 relative before:content-[''] before:absolute before:top-0 before:right-0 before:w-16 before:h-16 before:bg-[linear-gradient(135deg,rgba(85,158,160,0.1)_0%,rgba(13,31,65,0.05)_100%)] before:rotate-45 before:translate-x-8 before:-translate-y-8">
                  <div className="size-16 rounded-xl bg-accent flex items-center justify-center mb-4 text-ring relative overflow-hidden">
                    <div className="absolute inset-0 bg-gradient-to-br from-ring/10 to-transparent" />
                    <Icon className="size-8 relative z-10" strokeWidth={2} />
                  </div>
                  <CardTitle className="font-default text-xl text-primary font-bold">
                    {item.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground leading-relaxed font-default">
                    {item.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}